import React, { useState, useEffect, useRef } from "react";
import CountDownTimer from "../commonComponent/CountDownTimer";
export interface ITimerProps {
  duration: number;
  checkStatus: Function;
}
export default function PayTimer(props: ITimerProps) {
  return (
    <>
      <div className="paytimer-section">
        <div>Approve the payment within</div>
        <div>
          <CountDownTimer
            duration={props.duration}
            onTimerUpdate={props.checkStatus}
          />
        </div>

        <div className="mgt-10">minutes</div>
        <div className="mt-3">
          You will be redirected to status page, once a response is received
          from the service provider
        </div>
      </div>
    </>
  );
}
